import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0212a540"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body text-left" }
const _hoisted_3 = {
  key: 0,
  class: "user-data grid"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold inline-block" }, "Dettaglio Notifica", -1))
const _hoisted_5 = { class: "inline-block text-primary-400 pt-2" }
const _hoisted_6 = { class: "block date mt-4 w-2/12" }
const _hoisted_7 = { class: "place font-bold text-gray-600 pt-4" }
const _hoisted_8 = { class: "description pt-4" }
const _hoisted_9 = {
  key: 0,
  class: "documents-section grid grid-cols-3 gap-10 pt-8 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationDocument = _resolveComponent("NotificationDocument")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.notification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.notificationTypeString), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.datePrettyPrinted()) + ", " + _toDisplayString(_ctx.timePrettyPrinted()), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.notification.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.notification.description), 1),
            (_ctx.document)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_NotificationDocument, {
                    modelValue: _ctx.document,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}